export default {"src":"/_next/static/media/Export-factoring.1f4b7a39.svg","height":30,"width":35};